import Fullname from "../../component/Name";

const Addname = () => {
  return (
    <>
      <Fullname />
    </>
  );
};
export default Addname;
